import * as React from 'react';

export function SvgLinearDark(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <g clipPath="url(#clip0_11637_9734)">
        <path
          d="M3.22057 14.0741C3.18052 13.9034 3.38392 13.7958 3.50792 13.9198L10.0802 20.4921C10.2042 20.6161 10.0966 20.8195 9.9259 20.7794C6.60927 20.0014 3.9986 17.3907 3.22057 14.0741ZM3.00034 11.44C2.99716 11.491 3.01634 11.5408 3.05246 11.5769L12.4231 20.9475C12.4592 20.9837 12.509 21.0029 12.56 20.9997C12.9864 20.9731 13.4048 20.9169 13.8132 20.833C13.9508 20.8047 13.9986 20.6357 13.8993 20.5363L3.46367 10.1007C3.36434 10.0014 3.19526 10.0492 3.167 10.1868C3.08313 10.5952 3.0269 11.0136 3.00034 11.44ZM3.75797 8.34697C3.728 8.41425 3.74326 8.49288 3.79534 8.54497L15.455 20.2046C15.5071 20.2567 15.5857 20.272 15.653 20.242C15.9745 20.0988 16.2861 19.9373 16.5864 19.7589C16.6858 19.6999 16.7011 19.5633 16.6194 19.4816L4.51842 7.3806C4.43668 7.29887 4.30013 7.3142 4.24109 7.41358C4.06265 7.71389 3.90117 8.02547 3.75797 8.34697ZM5.27857 6.25332C5.21195 6.1867 5.20783 6.07985 5.27059 6.00958C6.92031 4.16268 9.32005 3 11.9913 3C16.9667 3 21 7.03331 21 12.0087C21 14.6799 19.8373 17.0797 17.9904 18.7294C17.9202 18.7922 17.8133 18.788 17.7467 18.7214L5.27857 6.25332Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11637_9734">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
